module.exports = __webpack_public_path__ + "img/logo-white.4cdef178.png";